import type { ReactNode } from 'react';

/** Erreur d'envoi d'un formulaire (message de l'API, une violation par ligne), suivie d'éventuels liens d'aide */
export function FormError({ error, children }: { error: string | null; children?: ReactNode }) {
  if (!error) return null;

  return (
    <div role="alert" className="space-y-1 text-sm text-destructive">
      <p className="whitespace-pre-line">{error}</p>
      {children}
    </div>
  );
}
